import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip'
import type { FC, ReactElement, ReactNode } from 'react'
import styles from './tooltip.module.css'

export interface TooltipProps {
  title: ReactNode
  children: ReactElement<Record<string, unknown>>
  placement?: 'top' | 'bottom' | 'left' | 'right'
  arrow?: boolean
  enterDelay?: number
  leaveDelay?: number
}

export const Tooltip: FC<TooltipProps> = ({
  title,
  children,
  placement = 'bottom',
  arrow,
  enterDelay = 600,
  leaveDelay = 0,
}) => {
  if (!title) {
    return children
  }

  return (
    <BaseTooltip.Provider>
      <BaseTooltip.Root>
        <BaseTooltip.Trigger render={children} delay={enterDelay} closeDelay={leaveDelay} />
        <BaseTooltip.Portal>
          <BaseTooltip.Positioner side={placement} className={styles.positioner}>
            <BaseTooltip.Popup className={styles.tooltip}>
              {title}
              {arrow ? <BaseTooltip.Arrow /> : null}
            </BaseTooltip.Popup>
          </BaseTooltip.Positioner>
        </BaseTooltip.Portal>
      </BaseTooltip.Root>
    </BaseTooltip.Provider>
  )
}
